import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Users, FileText, AlertCircle, Shield, Settings, DollarSign, Building2 } from 'lucide-react';

export function CoopersOldTab({ coopers, handleValidateCooper, t }) {
  return (
    <div className="space-y-6">
      {/* Statistiques COOPER'S */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="border-l-4 border-l-green-500">
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-600">COOPER'S Validés</p>
                <p className="text-3xl font-bold text-green-600">
                  {coopers.filter(c => c.is_validated).length}
                </p>
              </div>
              <div className="h-12 w-12 rounded-full bg-green-100 flex items-center justify-center">
                <Shield className="h-6 w-6 text-green-600" />
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-l-orange-500">
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-600">{t('admin_dashboard.pending', 'En Attente')}</p>
                <p className="text-3xl font-bold text-orange-600">
                  {coopers.filter(c => !c.is_validated).length}
                </p>
              </div>
              <div className="h-12 w-12 rounded-full bg-orange-100 flex items-center justify-center">
                <AlertCircle className="h-6 w-6 text-orange-600" />
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-l-blue-500">
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-600">{t('admin_dashboard.total_coopers', 'Total COOPER\'S')}</p>
                <p className="text-3xl font-bold text-blue-600">
                  {coopers.length}
                </p>
              </div>
              <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center">
                <Users className="h-6 w-6 text-blue-600" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Liste des COOPER'S */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Shield className="h-5 w-5 text-coppam-blue" />
            Gestion des COOPER'S
          </CardTitle>
          <CardDescription>
            Validez et gérez les partenaires du réseau ESS
          </CardDescription>
        </CardHeader>
        <CardContent>
          {coopers.length === 0 ? (
            <div className="text-center py-12">
              <Shield className="h-16 w-16 mx-auto text-slate-300 mb-4" />
              <p className="text-slate-600 font-medium">{t('admin_dashboard.no_coopers', 'Aucun COOPER\'S enregistré')}</p>
              <p className="text-sm text-slate-500 mt-2">
                Les nouveaux COOPER'S apparaîtront ici en attente de validation
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {coopers.map((cooper) => (
                <Card key={cooper.id} className={`border-2 transition-all hover:shadow-lg ${
                  cooper.is_validated
                    ? 'border-green-200 bg-green-50/30'
                    : 'border-orange-200 bg-orange-50/30'
                }`}>
                  <CardContent className="pt-6">
                    {/* En-tête avec statut */}
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <Building2 className="h-5 w-5 text-coppam-blue" />
                          <h3 className="font-bold text-lg text-slate-900">
                            {cooper.entreprise || 'N/A'}
                          </h3>
                        </div>
                        <p className="text-sm text-slate-600 font-mono">
                          SIRET: {cooper.siret || 'N/A'}
                        </p>
                      </div>
                      {cooper.is_validated ? (
                        <Badge className="bg-green-700 text-white font-semibold">
                          <Shield className="h-3 w-3 mr-1" />
                          Validé
                        </Badge>
                      ) : (
                        <Badge className="bg-orange-700 text-white font-semibold">
                          <AlertCircle className="h-3 w-3 mr-1" />
                          En attente
                        </Badge>
                      )}
                    </div>

                    {/* Informations de contact */}
                    <div className="space-y-2 mb-4 bg-white rounded-lg p-3">
                      <div className="flex items-center gap-2 text-sm">
                        <Users className="h-4 w-4 text-slate-500" />
                        <span className="text-slate-600">
                          Contact: {cooper.user?.prenom} {cooper.user?.nom}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 text-sm">
                        <FileText className="h-4 w-4 text-slate-500" />
                        <span className="text-slate-600">
                          Téléphone: {cooper.telephone || 'N/A'}
                        </span>
                      </div>
                    </div>

                    {/* Tarification */}
                    <div className="grid grid-cols-3 gap-2 mb-4">
                      <div className="bg-blue-50 rounded-lg p-2 text-center">
                        <p className="text-xs text-slate-600 mb-1">{t('admin_dashboard.annual_access', 'Accès annuel')}</p>
                        <p className="font-bold text-blue-600">
                          {cooper.cout_acces_annuel || 0}€
                        </p>
                      </div>
                      <div className="bg-blue-50 rounded-lg p-2 text-center">
                        <p className="text-xs text-slate-600 mb-1">{t('admin_dashboard.per_user', 'Par utilisateur')}</p>
                        <p className="font-bold text-blue-600">
                          {cooper.cout_par_utilisateur || 0}€
                        </p>
                      </div>
                      <div className="bg-blue-50 rounded-lg p-2 text-center">
                        <p className="text-xs text-slate-600 mb-1">{t('admin_dashboard.per_line', 'Par ligne')}</p>
                        <p className="font-bold text-blue-600">
                          {cooper.cout_par_ligne || 0}€
                        </p>
                      </div>
                    </div>

                    {/* Actions */}
                    {!cooper.is_validated && (
                      <Button
                        onClick={() => handleValidateCooper(cooper.id)}
                        data-testid={`validate-cooper-${cooper.id}`}
                        className="w-full bg-green-600 hover:bg-green-700"
                      >
                        <Shield className="h-4 w-4 mr-2" />
                        Valider ce COOPER'S
                      </Button>
                    )}
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export function ConfigOldTab({ t }) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader className="bg-gradient-to-r from-coppam-blue to-blue-600 text-white">
          <CardTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            Configuration Globale
          </CardTitle>
          <CardDescription className="text-white/90">
            Paramètres et tarifs de la plateforme
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Remises et Pénalités */}
            <Card className="border-2 border-blue-200 bg-blue-50/30">
              <CardContent className="pt-6">
                <div className="flex items-start gap-3 mb-4">
                  <div className="p-3 bg-blue-100 rounded-lg">
                    <DollarSign className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg text-slate-900">{t('admin_dashboard.discounts_penalties', 'Remises et Pénalités')}</h3>
                    <p className="text-sm text-slate-600">{t('admin_dashboard.pv_motivation_system', 'Système de motivation PV')}</p>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center justify-between p-3 bg-white rounded-lg">
                    <div className="flex items-center gap-2">
                      <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center">
                        <span className="text-green-600 font-bold">✓</span>
                      </div>
                      <span className="text-sm font-medium">{t('admin_dashboard.timely_discount', 'Remise dans les délais')}</span>
                    </div>
                    <span className="font-bold text-green-600">3,50€</span>
                  </div>

                  <div className="flex items-center justify-between p-3 bg-white rounded-lg">
                    <div className="flex items-center gap-2">
                      <div className="h-8 w-8 rounded-full bg-orange-100 flex items-center justify-center">
                        <span className="text-orange-600 font-bold">⏰</span>
                      </div>
                      <span className="text-sm font-medium">Pénalité retard</span>
                    </div>
                    <span className="font-bold text-orange-600">0,33€/jour</span>
                  </div>

                  <div className="p-3 bg-red-50 rounded-lg border border-red-200">
                    <div className="flex items-start gap-2">
                      <AlertCircle className="h-5 w-5 text-red-600 mt-0.5" />
                      <p className="text-sm text-red-800">
                        <strong>{t('admin_dashboard.blocking_non_delivery', 'Blocage en cas de non-remise dans l\'année civile')}</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Adhésion FTPE */}
            <Card className="border-2 border-green-200 bg-green-50/30">
              <CardContent className="pt-6">
                <div className="flex items-start gap-3 mb-4">
                  <div className="p-3 bg-green-100 rounded-lg">
                    <Shield className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg text-slate-900">{t('admin_dashboard.ftpe_membership', 'Adhésion FTPE')}</h3>
                    <p className="text-sm text-slate-600">{t('admin_dashboard.mandatory_condition', 'Condition obligatoire')}</p>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-6 text-center mb-4">
                  <p className="text-4xl font-bold text-green-600 mb-2">200€</p>
                  <p className="text-sm text-slate-600">par an</p>
                </div>

                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-sm">
                    <div className="h-2 w-2 rounded-full bg-green-600"></div>
                    <span className="text-slate-700">{t('admin_dashboard.mandatory_all_devices', 'Obligatoire pour tous les dispositifs')}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm">
                    <div className="h-2 w-2 rounded-full bg-green-600"></div>
                    <span className="text-slate-700">{t('admin_dashboard.annual_renewal', 'Renouvellement annuel')}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm">
                    <div className="h-2 w-2 rounded-full bg-green-600"></div>
                    <span className="text-slate-700">{t('admin_dashboard.ess_services_access', 'Accès aux services ESS')}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Informations complémentaires */}
          <Card className="mt-6 border-2 border-slate-200">
            <CardContent className="pt-6">
              <div className="flex items-start gap-3">
                <FileText className="h-5 w-5 text-slate-600 mt-1" />
                <div>
                  <h4 className="font-semibold text-slate-900 mb-2">Informations importantes</h4>
                  <ul className="text-sm text-slate-600 space-y-1">
                    <li>• Les tarifs sont susceptibles d'être modifiés avec préavis</li>
                    <li>• Les pénalités sont cumulatives</li>
                    <li>• Le blocage est levé dès régularisation de la situation</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>
        </CardContent>
      </Card>
    </div>
  );
}
